import { memo, useMemo } from "react";
import { AppTabBar } from "../../components/AppTabBar";
import { DEFAULT_APPLICATION_ID } from "../../constants";
import { AppsComponents } from "../../constants/ComponentList";
import { AUTH_KEYS } from "../../constants/Keys";
import { useContextApp } from "../../hooks";
import GenericAppComponent from "../../meta/GenericAppComponent";
import { useStyles } from "./styles";

export const AuthenticatedApp = memo(() => {
  const styles = useStyles();

  const { contextApp, setContextSelectedApp, ApplicationTabs, closeContextApp } = useContextApp();

  const component = useMemo(() => AppsComponents[contextApp.type], [contextApp.type]);

  return (
    <div key={AUTH_KEYS.CONTAINER} className={styles.container}>
      <div key={AUTH_KEYS.HEADER} className={styles.tabContainer}>
        <AppTabBar
          tabs={ApplicationTabs}
          onHomeButtonClicked={() => setContextSelectedApp(DEFAULT_APPLICATION_ID)}
          selectedTabId={contextApp.id}
          onCloseApp={closeContextApp}
          onSelectedAppChange={(tabId: string) => setContextSelectedApp(tabId)}
        />
      </div>
      <div key={AUTH_KEYS.BODY} className={styles.appContainer}>
        <GenericAppComponent as={component} appId={contextApp.id} onClose={closeContextApp} />
      </div>
    </div>
  );
});
